$(document).ready(function() {
  var $slick = $('.custom_slick');
  if ($slick.hasClass('slick-initialized')) {
    $slick.slick('unslick');
  }

  $slick.slick({
    autoplay: true,
    autoplaySpeed: 9000,
    speed: 1200,
    cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
    centerMode: true,
    centerPadding: '20%',
    slidesToShow: 1,
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="前へ"><svg width="24" height="44" viewBox="0 0 24 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 4L4 22L20 40" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="次へ"><svg width="24" height="44" viewBox="0 0 24 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4L20 22L4 40" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          centerMode: false,
          centerPadding: '0px',
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });
});